'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from 'react';
import * as SubframeCore from '@subframe/core';
import { FeatherChevronDown, FeatherColumns3 } from '@subframe/core';
import { Button, Checkbox } from '@/shared/components/ui';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchColunasDisponiveis, fetchColunasPreferencia, saveColunasPreferencia, selectColunasDisponiveis, selectColunasDisponiveisEscritorioId, selectColunasDisponiveisLoaded, selectColunasPreferenciaEscritorioId, selectColunasPreferenciaIds, selectColunasPreferenciaLoaded, selectColunasPreferenciaSaving } from '../store';
import type { ColunaDisponivel } from '../types';
interface ColunasDropdownProps {
  escritorioId: string | undefined;
}
export function ColunasDropdown(t0) {
  const $ = _c(50);
  const {
    escritorioId
  } = t0;
  const dispatch = useAppDispatch();
  const disponiveis = useAppSelector(selectColunasDisponiveis);
  const disponiveisLoaded = useAppSelector(selectColunasDisponiveisLoaded);
  const disponiveisEscritorioId = useAppSelector(selectColunasDisponiveisEscritorioId);
  const persistedIds = useAppSelector(selectColunasPreferenciaIds);
  const preferenciaLoaded = useAppSelector(selectColunasPreferenciaLoaded);
  const preferenciaEscritorioId = useAppSelector(selectColunasPreferenciaEscritorioId);
  const saving = useAppSelector(selectColunasPreferenciaSaving);
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [draftIds, setDraftIds] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== dispatch || $[2] !== disponiveisEscritorioId || $[3] !== disponiveisLoaded || $[4] !== escritorioId || $[5] !== preferenciaEscritorioId || $[6] !== preferenciaLoaded) {
    t2 = () => {
      if (!escritorioId) {
        return;
      }
      if (!disponiveisLoaded || disponiveisEscritorioId !== escritorioId) {
        dispatch(fetchColunasDisponiveis(escritorioId));
      }
      if (!preferenciaLoaded || preferenciaEscritorioId !== escritorioId) {
        dispatch(fetchColunasPreferencia(escritorioId));
      }
    };
    t3 = [escritorioId, disponiveisLoaded, disponiveisEscritorioId, preferenciaLoaded, preferenciaEscritorioId, dispatch];
    $[1] = dispatch;
    $[2] = disponiveisEscritorioId;
    $[3] = disponiveisLoaded;
    $[4] = escritorioId;
    $[5] = preferenciaEscritorioId;
    $[6] = preferenciaLoaded;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[9] !== open || $[10] !== persistedIds) {
    t4 = () => {
      if (open) {
        setDraftIds(persistedIds);
      }
    };
    t5 = [open, persistedIds];
    $[9] = open;
    $[10] = persistedIds;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  bb0: {
    if (draftIds.length !== persistedIds.length) {
      t6 = true;
      break bb0;
    }
    let t7;
    if ($[13] !== persistedIds) {
      t7 = new Set(persistedIds);
      $[13] = persistedIds;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    const set = t7;
    let t8;
    if ($[15] !== draftIds || $[16] !== set) {
      let t9;
      if ($[18] !== set) {
        t9 = id => !set.has(id);
        $[18] = set;
        $[19] = t9;
      } else {
        t9 = $[19];
      }
      t8 = draftIds.some(t9);
      $[15] = draftIds;
      $[16] = set;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    t6 = t8;
  }
  const isDirty = t6;
  let t7;
  if ($[20] !== disponiveis) {
    t7 = groupByCategory(disponiveis);
    $[20] = disponiveis;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const grouped = t7;
  const totalSelecionadas = persistedIds.length;
  let t8;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = fieldId => {
      setDraftIds(current => current.includes(fieldId) ? current.filter(id_0 => id_0 !== fieldId) : [...current, fieldId]);
    };
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const toggleField = t8;
  let t9;
  if ($[23] !== dispatch || $[24] !== draftIds) {
    t9 = async () => {
      await dispatch(saveColunasPreferencia(draftIds));
      setOpen(false);
    };
    $[23] = dispatch;
    $[24] = draftIds;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const handleSave = t9;
  let t10;
  let t11;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FeatherColumns3 />;
    t11 = <FeatherChevronDown />;
    $[26] = t10;
    $[27] = t11;
  } else {
    t10 = $[26];
    t11 = $[27];
  }
  const t12 = totalSelecionadas > 0 ? `Colunas (${totalSelecionadas})` : "Colunas";
  let t13;
  if ($[28] !== t12) {
    t13 = <SubframeCore.DropdownMenu.Trigger asChild={true}><Button variant="neutral-secondary" icon={t10} iconRight={t11}>{t12}</Button></SubframeCore.DropdownMenu.Trigger>;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="border-b border-neutral-100 px-4 py-3"><p className="text-default-font text-sm font-medium">Colunas extras</p><p className="text-subtext-color text-xs">Marque os campos que deseja ver na tabela</p></div>;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== disponiveis.length || $[32] !== disponiveisLoaded || $[33] !== draftIds || $[34] !== grouped) {
    t15 = disponiveis.length === 0 ? <p className="text-subtext-color px-2 py-3 text-sm">{disponiveisLoaded ? "Nenhuma coluna dispon\xEDvel para este escrit\xF3rio." : "Carregando\u2026"}</p> : grouped.map(t16 => {
      const {
        category,
        items
      } = t16;
      return <div key={category ?? "__sem_categoria__"} className="mb-2">{category && <p className="text-subtext-color px-2 py-1 text-xs font-medium tracking-wide uppercase">{category}</p>}{items.map(coluna => <label key={coluna.fieldId} className="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 hover:bg-neutral-50"><Checkbox checked={draftIds.includes(coluna.fieldId)} onCheckedChange={() => toggleField(coluna.fieldId)} /><span className="text-default-font text-sm">{coluna.label}</span></label>)}</div>;
    });
    $[31] = disponiveis.length;
    $[32] = disponiveisLoaded;
    $[33] = draftIds;
    $[34] = grouped;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15) {
    t16 = <div className="flex-1 overflow-auto px-2 py-2">{t15}</div>;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Button variant="neutral-tertiary" onClick={() => setOpen(false)}>Cancelar</Button>;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  const t18 = !isDirty || saving;
  let t19;
  if ($[39] !== handleSave || $[40] !== saving || $[41] !== t18) {
    t19 = <div className="flex items-center justify-end gap-2 border-t border-neutral-100 px-4 py-3">{t17}<Button variant="brand-primary" disabled={t18} loading={saving} onClick={handleSave}>Salvar</Button></div>;
    $[39] = handleSave;
    $[40] = saving;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t16 || $[44] !== t19) {
    t20 = <SubframeCore.DropdownMenu.Portal><SubframeCore.DropdownMenu.Content align="end" className="bg-default-background z-50 w-[320px] rounded-md border border-solid border-neutral-100 shadow-lg"><div className="flex max-h-[400px] flex-col">{t14}{t16}{t19}</div></SubframeCore.DropdownMenu.Content></SubframeCore.DropdownMenu.Portal>;
    $[43] = t16;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== open || $[47] !== t13 || $[48] !== t20) {
    t21 = <SubframeCore.DropdownMenu.Root open={open} onOpenChange={setOpen}>{t13}{t20}</SubframeCore.DropdownMenu.Root>;
    $[46] = open;
    $[47] = t13;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  return t21;
}
function groupByCategory(items: ColunaDisponivel[]) {
  const map = new Map<string | null, ColunaDisponivel[]>();
  for (const item of items) {
    const arr = map.get(item.category) ?? [];
    arr.push(item);
    map.set(item.category, arr);
  }
  return Array.from(map.entries()).map(([category, items]) => ({
    category,
    items
  })).sort((a, b) => (a.category ?? '').localeCompare(b.category ?? ''));
}